import React from 'react';

import { notification } from 'antd';
import { ConfigProps, IconType, NotificationApi } from 'antd/lib/notification';
import { useIntl } from 'react-intl';

const toast: NotificationApi = notification;

const dismiss = () => {
  toast.destroy();
};

/**
 * Display a toast on the top (mobile) or top-right (desktop) corner of the screen.
 *
 * @param message `string` Text contained in the toast.
 * @param type `string` Type of the toast. Can be `success`, `error`, `warning` or `info`.
 * @param duration `number` Amount of seconds the toast will be displayed, _optional_.
 * @param icon `string` Name of the icon to show (according to proper CSS classes defined elsewhere in the project), _optional_.
 * @param size `string` Size of the icon to show (according to proper CSS classes defined elsewhere in the project), _optional_.
 */
const openToast = (
  message: string | React.ReactNode,
  type: IconType,
  duration = 4,
  icon?: string,
  size?: string,
) => {
  const options: ConfigProps = {
    placement: 'custom' as 'topRight',
    duration: duration,
  };
  toast.config(options);

  toast.open({
    type: type && icon ? type : null,
    message,
    className: `notification-item ${type}${icon ? '' : ' text-center'}`,
    icon: icon ? (
      <div
        className={`icon icon--${icon} icon__${type}${
          size ? ` icon__${size}` : ''
        }`}
      />
    ) : null,
    onClick: dismiss,
  });
};

const messageOpenToast = (options: { id: string; points: string }): string => {
  const { formatMessage } = useIntl();
  const { id, points } = options;
  return formatMessage({ id }, { points });
};

export { openToast, messageOpenToast };
